import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, nextTick, ref, provide } from 'vue'
import { ElConfigProvider } from 'element-plus'
import {GlobalStore} from '@/pinia';
import zhCn from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/lib/locale/lang/en";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const globalStore = GlobalStore()

//刷新当前页面
const is_show = ref(true)
const reload = () => {
  is_show.value = false
  nextTick(() => {
    is_show.value = true
  })
}
provide('reload', reload)

// element 语言配置 默认中文
const i18nLocale = computed(() => {
  if (globalStore.language && globalStore.language === "zh") return zhCn;
  if (globalStore.language == "en") return en;
  return zhCn
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(i18nLocale) }, {
    default: _withCtx(() => [
      (is_show.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})